import { Component } from '@angular/core';
import {EsvgFiles} from 'frontier';
import {MatIcon} from '@angular/material/icon';

@Component({
  selector: 'lib-help-icon',
  standalone: true,
  imports: [
    MatIcon
  ],
  templateUrl: './help-icon.component.html',
  styleUrl: './help-icon.component.css'
})
export class HelpIconComponent {
  protected readonly EsvgFiles = EsvgFiles;
}
